
const storageUtil = require('../../utils/storage/storageUtil');
const stateManager = require('../../utils/state/stateManager.js');
const configurationManager = require('../../utils/config/configurationManager');

export async function loadMenu()
{
    var appConfig = configurationManager.getAppConfig();
    var previousOrders = await storageUtil.readData(storageUtil.PreviousOrdersStoreName, appConfig.webOrderingExpiryForCachedPreviousOrdersInMinutes);

    if (previousOrders == null)
        return [];

    return previousOrders;
}

export async function addOrder(order)
{
    var appConfig = configurationManager.getAppConfig();
    var previousOrders = await storageUtil.readData(storageUtil.PreviousOrdersStoreName, appConfig.webOrderingExpiryForCachedPreviousOrdersInMinutes);

    if (previousOrders == null)
        previousOrders = [];

    previousOrders.push(order);
    storageUtil.updateData(storageUtil.PreviousOrdersStoreName, previousOrders);
}

